import * as _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export const ActivityLocationFormMixin = {
    computed: {
        ...mapGetters({ locations: 'allLocations' })
    },
    watch: {
        locations(newValue, oldValue) {
            this.selectedLastAddedElement(newValue, oldValue, this.setLocationId);
        }
    },
    methods: {
        ...mapActions({
            openModal: 'openModal',
            getLocations: 'getAllLocations'
        }),
        async openLocationModal() {
            await this.$nextTick();
            this.openModal({
                modalName: 'LocationModal',
                callback: ({ submitted }) => submitted && this.getLocations(),
                options: { hideBulk: true } });
        },
        lastAddedElement(arr1, arr2) {
            if (!arr1 || !arr2) return;
            const [newElement] = _.differenceBy(arr1, arr2, 'id');
            return newElement;
        },
        selectedLastAddedElement(arr1, arr2, callback) {
            const newElement = this.lastAddedElement(arr1, arr2);
            newElement && callback(newElement);
        },
        formatLocation: el => el.name
    },
    created() {
        this.$route.params.id && this.setValid();
        this.getLocations();
    }
};


// WEBPACK FOOTER //
// ./src/mixins/ActivityLocationFormMixin.js